import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

interface Actor {
  id: string;
  name: string;
  image: string;
  age?: number;
  vibe?: string;
}

// Import the same baddie characters from NoFilter (we'll move this to a shared file ideally)
const baddieCharacters: Actor[] = [
  {
    id: "baddie25",
    name: "Ruby",
    image: "/baddies/baddie25.jpg",
    age: 22,
    vibe: "fiery",
  },
  {
    id: "baddie26",
    name: "Aurora",
    image: "/baddies/baddie26.jpg",
    age: 20,
    vibe: "radiant",
  },
  {
    id: "baddie27",
    name: "Stella",
    image: "/baddies/baddie27.jpg",
    age: 21,
    vibe: "captivating",
  },
  {
    id: "anime1",
    name: "Megumin",
    image: "/baddies/anime1.jpg",
    age: 20,
    vibe: "kawaii",
  },
  {
    id: "baddie28",
    name: "Ivy",
    image: "/baddies/baddie28.jpg",
    age: 19,
    vibe: "enchanting",
  },
  {
    id: "baddie29",
    name: "Willow",
    image: "/baddies/baddie29.jpg",
    age: 23,
    vibe: "alluring",
  },
  {
    id: "baddie30",
    name: "Hazel",
    image: "/baddies/baddie30.jpg",
    age: 20,
    vibe: "magnetic",
  },
  {
    id: "baddie31",
    name: "Jade",
    image: "/baddies/baddie31.jpg",
    age: 21,
    vibe: "exotic",
  },
  {
    id: "anime2",
    name: "Megumin",
    image: "/baddies/anime2.jpg",
    age: 22,
    vibe: "enigmatic",
  },
  {
    id: "baddie32",
    name: "Sienna",
    image: "/baddies/baddie32.jpg",
    age: 19,
    vibe: "seductive",
  },
  {
    id: "baddie33",
    name: "Violet",
    image: "/baddies/baddie33.jpg",
    age: 22,
    vibe: "mysterious",
  },
  {
    id: "baddie34",
    name: "Luna Rose",
    image: "/baddies/baddie34.jpg",
    age: 20,
    vibe: "dreamy",
  },
  {
    id: "baddie1",
    name: "Aria",
    image: "/baddies/baddie1.jpg",
    age: 21,
    vibe: "confident",
  },
  {
    id: "baddie17",
    name: "Scarlett",
    image: "/baddies/baddie17.jpg",
    age: 22,
    vibe: "sassy",
  },
  {
    id: "baddie18",
    name: "Madison",
    image: "/baddies/baddie18.jpg",
    age: 20,
    vibe: "bubbly",
  },
  {
    id: "anime3",
    name: "Mitsuri",
    image: "/baddies/anime3.jpg",
    age: 19,
    vibe: "ethereal",
  },
  {
    id: "baddie19",
    name: "Victoria",
    image: "/baddies/baddie19.jpg",
    age: 23,
    vibe: "elegant",
  },
  {
    id: "baddie20",
    name: "Jasmine",
    image: "/baddies/baddie20.jpg",
    age: 19,
    vibe: "mysterious",
  },
  {
    id: "baddie2",
    name: "Luna",
    image: "/baddies/baddie2.jpg",
    age: 18,
    vibe: "dreamy",
  },
  {
    id: "baddie3",
    name: "Nova",
    image: "/baddies/baddie3.jpg",
    age: 22,
    vibe: "fierce",
  },
  {
    id: "baddie4",
    name: "Sophia",
    image: "/baddies/baddie4.jpg",
    age: 21,
    vibe: "sweet",
  },
  {
    id: "baddie5",
    name: "Isabella",
    image: "/baddies/baddie5.jpg",
    age: 20,
    vibe: "playful",
  },
  {
    id: "baddie6",
    name: "Mia",
    image: "/baddies/baddie6.jpg",
    age: 19,
    vibe: "cheerful",
  },
  {
    id: "baddie7",
    name: "Charlotte",
    image: "/baddies/baddie7.jpg",
    age: 22,
    vibe: "bold",
  },
  {
    id: "baddie8",
    name: "Amelia",
    image: "/baddies/baddie8.jpg",
    age: 21,
    vibe: "adventurous",
  },
  {
    id: "anime4",
    name: "Power",
    image: "/baddies/anime4.jpg",
    age: 21,
    vibe: "mesmerizing",
  },
  {
    id: "baddie9",
    name: "Harper",
    image: "/baddies/baddie9.jpg",
    age: 20,
    vibe: "fun",
  },
  {
    id: "baddie10",
    name: "Evelyn",
    image: "/baddies/baddie10.jpg",
    age: 23,
    vibe: "sophisticated",
  },
  {
    id: "baddie11",
    name: "Abigail",
    image: "/baddies/baddie11.jpg",
    age: 19,
    vibe: "energetic",
  },
  {
    id: "baddie12",
    name: "Emily",
    image: "/baddies/baddie12.jpg",
    age: 22,
    vibe: "charming",
  },
  {
    id: "baddie13",
    name: "Elizabeth",
    image: "/baddies/baddie13.jpg",
    age: 21,
    vibe: "graceful",
  },
  {
    id: "baddie14",
    name: "Mila",
    image: "/baddies/baddie14.jpg",
    age: 20,
    vibe: "flirty",
  },
  {
    id: "baddie15",
    name: "Ella",
    image: "/baddies/baddie15.jpg",
    age: 19,
    vibe: "cute",
  },
  {
    id: "baddie16",
    name: "Avery",
    image: "/baddies/baddie16.jpg",
    age: 18,
    vibe: "gentle",
  },
  {
    id: "baddie21",
    name: "Zoe",
    image: "/baddies/baddie21.jpg",
    age: 22,
    vibe: "sultry",
  },
  {
    id: "baddie22",
    name: "Lily",
    image: "/baddies/baddie22.jpg",
    age: 21,
    vibe: "innocent",
  },
  {
    id: "baddie23",
    name: "Grace",
    image: "/baddies/baddie23.jpg",
    age: 20,
    vibe: "elegant",
  },
  {
    id: "baddie24",
    name: "Chloe",
    image: "/baddies/baddie24.jpg",
    age: 19,
    vibe: "spicy",
  },
];

const NoFilterActors: React.FC = () => {
  const navigate = useNavigate();
  const [flippedCard, setFlippedCard] = useState<string | null>(null);

  const handleInfoClick = (e: React.MouseEvent, characterId: string) => {
    e.stopPropagation();
    setFlippedCard(flippedCard === characterId ? null : characterId);
  };

  const handleCharacterClick = (character: Actor) => {
    // Same behavior as NoFilter page - navigate to image-to-video with character
    navigate("/video/i2v", {
      state: {
        referenceImage: character.image,
        selectedModel: "wan2.2-nofilter",
        noFilterMode: true,
      },
    });
  };

  return (
    <div className="min-h-screen bg-black dark:bg-black p-6 pb-32 md:pb-6 transition-colors duration-300">
      <div className="max-w-7xl mx-auto space-y-8">
        {/* Header */}
        <div className="relative text-center mb-8 rounded-2xl border border-gray-200 dark:border-gray-700 p-8 overflow-hidden">
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center opacity-50 dark:opacity-40"
            style={{ backgroundImage: "url(/bg.png)" }}
          ></div>

          {/* Content with relative positioning */}
          <div className="relative z-10">
            <div className="flex items-center justify-center gap-3 mb-4">
              <button
                onClick={() => navigate("/no-filter")}
                className="text-gray-600 dark:text-white hover:text-gray-900 dark:hover:text-blue-400 transition-colors"
              >
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white">
                All Actors
              </h1>
            </div>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              Browse all {baddieCharacters.length} actors available for
              unfiltered content generation
            </p>
          </div>
        </div>

        {/* All Characters Grid */}
        <div>
          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
            {baddieCharacters.map((character) => {
              const isFlipped = flippedCard === character.id;
              return (
                <div
                  key={character.id}
                  className="group relative cursor-pointer rounded-xl bg-gray-900 dark:bg-gray-900 border-2 border-white/20 dark:border-white/20 hover:border-white/40 dark:hover:border-white/40 hover:shadow-[0_0_20px_rgba(255,255,255,0.1)] transition-all duration-300 hover:-translate-y-1"
                  style={{ perspective: "1000px" }}
                >
                  <div
                    className={`relative w-full aspect-square transition-transform duration-700 transform-style-preserve-3d ${
                      isFlipped ? "rotate-y-180" : ""
                    }`}
                    style={{
                      transformStyle: "preserve-3d",
                      transform: isFlipped
                        ? "rotateY(180deg)"
                        : "rotateY(0deg)",
                    }}
                  >
                    {/* Front of card */}
                    <div
                      className="absolute inset-0 w-full h-full rounded-xl overflow-hidden backface-hidden"
                      style={{ backfaceVisibility: "hidden" }}
                      onClick={() => handleCharacterClick(character)}
                    >
                      <img
                        src={character.image}
                        alt={character.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                      <div className="absolute bottom-0 left-0 right-0 p-2 transform translate-y-full group-hover:translate-y-0 transition-transform duration-200">
                        <h3 className="text-white font-semibold text-sm text-center drop-shadow-lg">
                          {character.name}
                        </h3>
                      </div>
                      {/* Info icon */}
                      <button
                        onClick={(e) => handleInfoClick(e, character.id)}
                        className="absolute top-1 right-1 w-4 h-4 md:w-6 md:h-6 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center text-white text-[10px] md:text-sm font-bold transition-all duration-200 hover:scale-110"
                        style={{ minWidth: "unset", minHeight: "unset" }}
                      >
                        i
                      </button>
                    </div>

                    {/* Back of card */}
                    <div
                      className="absolute inset-0 w-full h-full rounded-xl overflow-hidden backface-hidden bg-white dark:bg-gray-800 flex flex-col items-center justify-center text-gray-800 dark:text-gray-200 p-4 border-2 border-gray-200 dark:border-gray-700 transition-colors duration-300"
                      style={{
                        backfaceVisibility: "hidden",
                        transform: "rotateY(180deg)",
                      }}
                      onClick={() => handleCharacterClick(character)}
                    >
                      <div className="text-center">
                        <h3 className="text-lg font-bold mb-2 text-gray-900 dark:text-white">
                          {character.name}
                        </h3>
                        <div className="space-y-1">
                          <p className="text-sm text-gray-700 dark:text-gray-300">
                            <span className="font-semibold">Age:</span>{" "}
                            {character.age}
                          </p>
                          <p className="text-sm text-gray-700 dark:text-gray-300">
                            <span className="font-semibold">Vibe:</span>{" "}
                            {character.vibe}
                          </p>
                        </div>
                      </div>
                      {/* Info icon on back */}
                      <button
                        onClick={(e) => handleInfoClick(e, character.id)}
                        className="absolute top-1 right-1 w-4 h-4 md:w-6 md:h-6 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-full flex items-center justify-center text-gray-600 dark:text-gray-300 text-[10px] md:text-sm font-bold transition-all duration-200 hover:scale-110"
                        style={{ minWidth: "unset", minHeight: "unset" }}
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoFilterActors;
